import {SActionBtn, SIDRender, SLowcodeList, STableActions, SDropdown} from "shj-components";
import config from "./config.tsx";
import React, {useEffect, useRef, useState} from "react";
import {getAuth} from "@/utils/auth.ts";
import {message, Tag, TreeSelect} from "antd";
import CheckThePhone from "@/components/CheckThePhone";
import {isNil} from "lodash-es";
import {useNavigate} from "react-router-dom";
import {clueExport, getClueDetail, getCluePage, importExportTaskDownloadExcel} from "@/services/saleOpServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import AddNewPlanModal from "@/components/AddNewPlanModal";
import {useSetState} from "ahooks";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import {getChannelBrandAgent, getChannels, getChannelType} from "@/services/getUsers.ts";
import {getAllCompanyMrn, getRealEstateList} from "@/services/customerServices.ts";
import {departmentTree} from "@/services/content.ts";
import {filterSearchData, isHeadquarters} from "@/utils/common.ts";
import {getAnchorFn, getUserIdentityFn} from "@/pages/clueManage/utils.tsx";
import wx_add from '@/assets/wx_add.svg'
import wx_add_ok from '@/assets/wx_add_ok.svg'
import {fileConfirm} from "@/utils/file.ts";
import ExportModal from './components/ExportModal.tsx'
import AllowcateWorkerModal from "@/components/AllowcateWorkerModal";
import {getUser} from "@/common/utils.ts";
import KeepAlive from "react-activation";
import {openInNewTab} from "@/utils/queryParse.ts";

const ClueListNew = (props) => {
  const {companyId} = getUser()
  const navigate = useNavigate()
  const listRef = useRef<any>()
  const [sourceChannel, setSourceChannel] = useState([])
  const [state, setState] = useSetState({
    open: false,
    record: {},
    exportOpen: false,
    exportCode: 'ClueInfoDyhExcelImpl',
    changeDispatcherOpen: false, //改派
    batchEditId: [],
  })
  useEffect(() => {
    if (props?.clueStatus !== null) {
      listRef.current?.reload()
    }
  }, [props.clueStatus]);

  useEffect(() => {
    onCompanyChange(companyId)
  }, [companyId]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      const {deptId, ucenterUserId} = query
      if (deptId || ucenterUserId) {
        query.relativesRequest = {
          deptId,
          ucenterUserId,
          dutyType: ucenterUserId && "subsidiary.salesman"
        }
      }
      const newQuery = filterSearchData(query, ['firstDate'])
      if(props.clueStatus != null) {
        newQuery['status'] = props.clueStatus
      }
      delete newQuery.deptId
      delete newQuery.ucenterUserId
      getCluePage({params: {pageId: current, pageSize}, data: {...newQuery}}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => {
    setState({open: true})
  }

  const onEdit = (record) => {
    setState({open: true})
    getClueDetail(record.id).then(res => {
      setState({record: res})
    })
  }

  const getStatusOptions = () => {
    return Promise.all([
      httpOrgList(),
      getChannels(),
      getChannelBrandAgent(),
      getChannelType(),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.ClueStatusEnum'),
      getAnchorFn('ADVERT'),
      getUserIdentityFn(),
    ]).then(resp => {
      setSourceChannel(resp[1])
      return {
        companyList: resp[0],
        channels: resp[1],
        channelBrand: resp[2],
        channelType: resp[3],
        typeListArr: resp[4],
        clueStatusEnum: resp[5],
        anchor: resp[6],
        seat: resp[7],
      }
    })
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      getRealEstateList({orgId: value}).then(res => {
        listRef?.current?.updateSearchData('buildingId', res)
      })
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('saleDept', res)
      })
    } else {
      listRef?.current?.updateSearchData('buildingId', [])
      listRef?.current?.updateSearchData('saleDept', [])
    }
  }

  const onMarketerDepChange = (v) => {
    if (v) {
      getAllCompanyMrn({directlyUnder: {orgId: v, includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('salesman', res)
      })
    } else {
      listRef?.current?.updateSearchData('salesman', [])
    }
  }

  const onSearchReset = () => {
    listRef?.current?.updateSearchData('buildingId', [])
    listRef?.current?.updateSearchData('saleDept', [])
    listRef?.current?.updateSearchData('salesman', [])
  }

  // 导出
  const onExport = async () => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    message.loading({content: '导出中'})
    clueExport(searchData_)
        .then(() => {
          message.destroy()
          fileConfirm()
        })
        .catch(() => {
          message.destroy()
        })
  }
  // 导出压缩包
  const onExportZip = async () => {
    setState({exportOpen: true, exportCode: 'ClueInfoDyhExcelImpl'})
  }
  // 导出明细
  const onExportDetail = async () => {
    setState({exportOpen: true, exportCode: 'ClueFollowLogExcelImpl'})
  }

  const onChangeEmp = (batchEditId) => {
    setState({batchEditId, changeDispatcherOpen: true})
  }

  const onBatchChange = ({selectedRowKeys}) => {
    onChangeEmp(selectedRowKeys)
  }

  const extension = {
    onSearchReset,
    request: {fetchList, getStatusOptions},
    events: {onAdd, onCompanyChange, onMarketerDepChange, onBatchChange},
    auth: getAuth(),
    rowKey: 'id',
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      treeSelect(props: any) {
        const {key, placeholder}: any = props
        return (
            <TreeSelect
                key={key}
                placeholder={placeholder || '请选择客户来源'}
                allowClear
                treeCheckable
                showSearch
                treeData={sourceChannel}
                maxTagCount="responsive"
                popupMatchSelectWidth={false}
                fieldNames={{label: 'label', value: 'id', children: 'children'}}
                treeNodeLabelProp={'label'}
                style={{width: '100%'}}
            />
        )
      },
      clueIdRender(text: any, record: any, index: any) {
        let label = text
        if (record?.sourceFlag == 'CONTENT_SHARING') {
          label += `-内`
        }
        return (
            <SIDRender
                id={label}
                onClick={() => {
                  openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}?authKey=clueList`)
                }}
            />
        )
      },
      checkPhone(text: any, record: any, index: any) {
        return (
            <CheckThePhone
                clueId={record.id}
                initValue={text}
                auth="clueViewPhone"
            />
        )
      },
      grossInfoRender(text: any, record: any, index: any) {
        if (isNil(text)) return '待定'
        if (text || text == 'true') return '是'
        if (!text || text == 'false') return '否'
      },
      publicCell(text: any, record: any, index: any) {
        let content = '线索列表'
        switch (record?.publicSea) {
          case 'public_seat':
            content = '呼叫公海池'
            break
          case 'public_sales':
            content = '营销公海池'
            break
          case 'public_fangao':
            content = '梵高CC回访池'
            break
          case 'public_temp':
            content = '待二次派单'
            break
        }
        switch (record?.collisionFlag) {
          case true:
            content = '撞单异常'
            break
        }
        if (!!record?.dispatchExceptionType && record?.dispatchExceptionType != 'none') {
          content = '派单异常'
        }
        return content
      },
      stateRender(text) {
        return <Tag color='pink'>{text}</Tag>
      },
      nameRender(v, record) {
        return <div style={{display: 'flex'}}>
          <img style={{width: 20, height: 20, marginRight: 5}} src={record.salesAddQvFlag ? wx_add_ok : wx_add}/>
          {v}
        </div>
      },
      actionRender(_, record) {
        return <STableActions>
          <SActionBtn auth={'clueInfoEdit'} onClick={() => onEdit(record)}>编辑</SActionBtn>
          <SActionBtn auth={'reassignmentSale'}
                      onClick={() => onChangeEmp([record.id])}>改派营销员</SActionBtn>
        </STableActions>
      },
      exportRender() {
        const items = [
          {
            label: '导出',
            key: 'ClueExportButton',
            auth: 'ClueExportButton',
            onClick: onExport,
          },
          {
            label: '导出明细',
            key: 'ClueExportDetailsButton',
            auth: 'ClueExportDetailsButton',
            onClick: onExportDetail,
          },
          {
            label: '导出（Zip）',
            key: 'ClueExportZipButton',
            auth: 'ClueExportZipButton',
            onClick: onExportZip,
          },
        ]
        return (
            <SDropdown menu={{items}} dropdownType="Button">
              导出
            </SDropdown>
        )
      },
    },
  }

  return (
    <KeepAlive name={location.pathname}>
      <>
        <SLowcodeList config={{...config, [isHeadquarters() ? '' : 'searchInitialValues']: {orgId: companyId}}} ref={listRef} searchMode="group" {...extension} />
        {state.open && <AddNewPlanModal basicInfo={state.record || {}}
                                        editReload={listRef.current?.reload}
                                        reload={listRef.current?.reload}
                                        isEdit={state?.record?.id} open={state.open}
                                        onClose={() => setState({open: false, record: {}})}
        />}
        <ExportModal open={state.exportOpen} taskCode={state.exportCode} onClose={() => setState({exportOpen: false})}/>
        {/** 分配服务人员弹窗 */}
        {state.changeDispatcherOpen &&
            <AllowcateWorkerModal isEditTitle={'改派'} isListOperation={true}
                                  buttonKey={'ASSIGN_SALES'}
                                  reload={listRef.current?.reload}
                                  isBatch={true}
                                  editId={state.batchEditId} open={state.changeDispatcherOpen}
                                  onClose={() => setState({changeDispatcherOpen: false})}/>}
      </>
    </KeepAlive>
  )
}

export default ClueListNew